import type { JobPortalOffer } from '@eliadmin/core/src/api/jobportal/offers-api';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import Link from '@eliadmin/core/src/components/link';

export const CategoryBadge = ({
  category,
  item,
  maxWidth,
  asLink = true,
}: {
  category?: JobPortalOffer['categories'][0];
  item?: { name: string; slug: string };
  maxWidth?: string;
  asLink?: boolean;
}) => {
  const className = cn(
    'flex h-[22px] items-center rounded-[8px] bg-primary/10 px-2 text-[10px] font-medium leading-[22px] text-primary md:h-[33px] md:text-xs',
  );

  const content = (
    <span className={cn('min-w-0 overflow-hidden whitespace-nowrap', maxWidth && 'truncate')}>
      {category?.name ?? item?.name ?? 'Template'}
    </span>
  );

  if (!asLink) {
    return (
      <div className={className} style={maxWidth ? { maxWidth } : {}}>
        {content}
      </div>
    );
  }

  return (
    <Link
      prefetch={false}
      href="/ponuky"
      className={className}
      style={maxWidth ? { maxWidth } : {}}
    >
      {content}
    </Link>
  );
};
